var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38432 3.52971C5.3322 3.52971 2.85797 5.88772 2.85797 8.79648C2.85797 11.7052 5.3322 14.0633 8.38432 14.0633C11.4364 14.0633 13.9107 11.7052 13.9107 8.79648C13.9107 5.88772 11.4364 3.52971 8.38432 3.52971ZM0.0947876 8.79665C0.0947876 4.43351 3.80613 0.896484 8.38431 0.896484C12.9625 0.896484 16.6738 4.43351 16.6738 8.79665C16.6738 10.5029 16.1063 12.0827 15.1412 13.3741L21.7955 19.7159C22.335 20.23 22.335 21.0638 21.7955 21.5779C21.256 22.0921 20.3812 22.0921 19.8417 21.5779L13.1874 15.2362C11.8323 16.1559 10.1746 16.6968 8.38431 16.6968C3.80613 16.6968 0.0947876 13.1598 0.0947876 8.79665Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.68ac1fd7b7186a128fd6e261555038b0.svg";
export { ForwardRef as ReactComponent };